import { Link } from 'react-router-dom';
import { finaleImage } from '@/mocks/site';
import InquiryForm from './InquiryForm';

export default function Finale() {
  return (
    <>
      <section id="contact" aria-label="Contact" className="relative h-[100svh] min-h-[560px] overflow-hidden bg-foreground-950 text-background-50" data-scrub="zoom">
        <img src={finaleImage.src} alt={finaleImage.alt} className="absolute inset-0 h-full w-full object-cover object-top" />
        <div className="absolute inset-0 bg-foreground-950/50" />
        <div className="relative flex h-full flex-col justify-between px-4 md:px-6 pt-24 pb-10">
          <div data-reveal="up">
            <p className="font-label text-[11px] uppercase tracking-[0.18em] text-background-200">Contact / 06</p>
            <h2 className="mt-4 text-2xl md:text-4xl font-bold tracking-[-0.04em] leading-[1.02] max-w-[520px]">Have an idea worth bringing to life? We&apos;d love to hear it.</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-end">
            <Link to="/contact" className="group w-fit cursor-pointer">
              <span className="block font-label text-[11px] uppercase tracking-[0.18em] text-background-200">01 / Have a brief</span>
              <span className="mt-2 block border-b-2 border-background-50/70 pb-2 font-extrabold tracking-[-0.055em] leading-[0.9] text-[clamp(3rem,8vw,8rem)] group-hover:text-primary-300 group-hover:border-primary-300 transition-colors whitespace-nowrap">
                Start a Project
              </span>
            </Link>
            <Link to="/contact" className="group w-fit md:justify-self-end cursor-pointer">
              <span className="block font-label text-[11px] uppercase tracking-[0.18em] text-background-200">02 / Just saying hello</span>
              <span className="mt-2 block border-b-2 border-background-50/70 pb-2 font-extrabold tracking-[-0.055em] leading-[0.9] text-[clamp(3rem,8vw,8rem)] group-hover:text-primary-300 group-hover:border-primary-300 transition-colors whitespace-nowrap">
                Contact Us
              </span>
            </Link>
          </div>
        </div>
      </section>

      <section id="inquiry" aria-label="Project inquiry" className="bg-accent-100 py-16 md:py-20 scroll-mt-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 px-4 md:px-6">
          <div className="lg:col-span-4">
            <h2 className="text-3xl md:text-4xl font-extrabold tracking-[-0.045em] leading-[0.95]">Tell us what you&apos;re imagining.</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-800 max-w-[320px]">A few lines is plenty. A producer reads every message personally.</p>
          </div>
          <div className="lg:col-span-7 lg:col-start-6">
            <InquiryForm />
          </div>
        </div>
      </section>
    </>
  );
}